// import * as models from 'smg/models';
import { NewQuoteRequest } from 'smg/customer-api/quoterequests';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import Modal from 'smg/modal';
import * as uploads from 'smg/uploads';
import * as html from 'smg/html';
import * as luxon from 'luxon';
import { HandleRequestError } from 'smg/errors';
import { Start, Stop } from 'smg/buttons';

const $bannerQuoteForm = document.querySelector('.banner-quote-form');

if ($bannerQuoteForm) {
    main();
}

function main() {
    const $formPg1 = $bannerQuoteForm?.querySelector<HTMLFormElement>('#banner-quote-form-pg-1');
    const $qty = $formPg1?.querySelector<HTMLInputElement>('#banner-quote-quantity');
    const $name = $formPg1?.querySelector<HTMLInputElement>('#banner-quote-full-name');
    const $email = $formPg1?.querySelector<HTMLInputElement>('#banner-quote-email');
    const $phone = $formPg1?.querySelector<HTMLInputElement>('#banner-quote-phone');
    const $sms = $formPg1?.querySelector<HTMLInputElement>('#banner-quote-sms');
    const $pg1next = $formPg1?.querySelector<HTMLButtonElement>('.next-step');

    const $formPg2 = $bannerQuoteForm?.querySelector<HTMLFormElement>('#banner-quote-form-pg-2');
    const $company = $formPg2?.querySelector<HTMLInputElement>('#banner-quote-company');
    const $date = $formPg2?.querySelector<HTMLInputElement>('#banner-quote-date-needed');
    const $notes = $formPg2?.querySelector<HTMLInputElement>('#banner-quote-notes');
    const $uploadLabel = $formPg2?.querySelector<HTMLLabelElement>('#banner-quote-upload');
    const $pg2prev = $formPg2?.querySelector<HTMLButtonElement>('.prev-step');
    const $pg2submit = $formPg2?.querySelector<HTMLButtonElement>('button[type="submit"]');

    const p = new Phone($phone as HTMLInputElement);
    const u = new uploads.Uploader($uploadLabel as HTMLLabelElement, {
        confirmBtn: $pg2submit ?? undefined,
    });

    const pageLineItem = $bannerQuoteForm?.getAttribute('data-line-item');
    const pageProduct = $bannerQuoteForm?.getAttribute('data-page-product');

    function showPage(page: number) {
        switch (page) {
        case 1:
            $formPg1?.classList.remove('d-none');
            $formPg2?.classList.add('d-none');
            break;
        case 2:
            $formPg1?.classList.add('d-none');
            $formPg2?.classList.remove('d-none');
            break;
        default:
            break;
        }
    }

    $pg1next?.addEventListener('click', e => {
        e.preventDefault();
        if (!ReportValidity($formPg1 as HTMLFormElement)) {
            return;
        }
        showPage(2);
    });

    $pg2prev?.addEventListener('click', e => {
        e.preventDefault();
        showPage(1);
    });

    $bannerQuoteForm?.addEventListener('submit', async e => {
        e.preventDefault();
        if (!ReportValidity($formPg1 as HTMLFormElement) || !ReportValidity($formPg2 as HTMLFormElement)) {
            return;
        }
        Start($pg2submit as HTMLButtonElement);
        await NewQuoteRequest({
            name: $name?.value || '',
            company: $company?.value || '',
            phone: p,
            email: $email?.value || '',
            lineItem: pageLineItem || '',
            quantity: parseInt($qty?.value || '0', 10),
            dateNeeded: $date?.value,
            form: `banner - ${pageProduct || ''}`,
            notes: `I am interested in ordering ${pageProduct || ''} as shown on ${window.location.href}.\n\n${$notes?.value || ''}`,
            uploader: u,
            sms: $sms?.checked,
        }).then(quoteRequest => {
            const $body = html.FromString(`<div>
                <p>
                    We received your quote request! You should hear back from us within one business day.
                </p>

                <h3>Here's what you requested:</h3>

                <ul></ul>

                </div>`);

            const $ul = $body.querySelector('ul') as HTMLElement;

            if (quoteRequest.firstName || quoteRequest.lastName) {
                $ul.appendChild(html.FromString(`<li><strong>Name:</strong> ${html.Escape(`${quoteRequest.firstName ?? ''} ${quoteRequest.lastName ?? ''}`)}</li>`));
            }

            if (quoteRequest.company) {
                $ul.appendChild(html.FromString(`<li><strong>Company:</strong> ${html.Escape(quoteRequest.company)}</li>`));
            }

            if (quoteRequest.email) {
                $ul.appendChild(html.FromString(`<li><strong>Email:</strong> ${html.Escape(quoteRequest.email)}</li>`));
            }

            if (quoteRequest.phone) {
                $ul.appendChild(html.FromString(`<li><strong>Phone:</strong> ${html.Escape(quoteRequest.phone)}</li>`));
            }

            $ul.appendChild(html.FromString('<li><strong>Product:</strong> Challenge Coins</li>'));

            if (quoteRequest.quantity) {
                $ul.appendChild(html.FromString(`<li><strong>Quantity:</strong> ${Intl.NumberFormat().format(quoteRequest.quantity)}</li>`));
            }

            if (quoteRequest.dateNeeded) {
                $ul.appendChild(html.FromString(`<li><strong>Date Needed:</strong> ${html.Escape(luxon.DateTime.fromISO(quoteRequest.dateNeeded).toLocaleString(luxon.DateTime.DATE_FULL))}</li>`));
            }

            if ($notes?.value) {
                $ul.appendChild(html.FromString(`<li><strong>Notes:</strong> ${html.Escape($notes.value)}</li>`));
            }

            new Modal({
                title: 'Success!',
                body: $body,
                cancelText: 'Close',
                cancelButtonClass: 'btn btn-primary w-100',
                onClose: () => {
                    window.location.reload();
                },
            });
        }).catch(HandleRequestError).
            finally(() => Stop($pg2submit as HTMLButtonElement));
    });
}
